import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Modal from 'flarum/common/components/Modal';

/**
 * v0.4.7 #365 — 设置 Modal
 *
 * 单一开关: 启用图片剪裁 (默认 ON)
 * 持久化: localStorage 'seedream.cropEnabled' (per-user per-browser)
 *
 * 关键: 用 content() 方法, 不能用 view() (v0.4.7a #364 教训)
 *   view() 覆盖父类 → .Modal.Modal--normal.SettingsModal 容器不存在
 *   → className() 返回的 'SettingsModal Modal--normal' 永远没应用
 *   → 所有 .SettingsModal xxx CSS 不命中
 */
export default class SettingsModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);

    // 从 localStorage 读开关状态 — 默认 ON (null !== 'false')
    // 显式 'false' 才算关闭
    this.cropEnabled = localStorage.getItem('seedream.cropEnabled') !== 'false';
  }
  className() {
    return 'SettingsModal Modal--normal';
  }
  title() {
    return app.translator.trans('ziven-dress-up.forum.settings.title');
  }

  /**
   * 切换开关
   */
  toggleCrop() {
    this.cropEnabled = !this.cropEnabled;
    localStorage.setItem('seedream.cropEnabled', String(this.cropEnabled));
    m.redraw();
  }

  /**
   * content() — #365 关键: 用 content() 不要用 view()
   */
  content() {
    return m("div", {
      class: "Modal-body SettingsModal-body"
    }, m("div", {
      class: "setting-row"
    }, m("div", {
      class: "setting-info"
    }, m("div", {
      class: "setting-name"
    }, app.translator.trans('ziven-dress-up.forum.settings.crop_enabled.name')), m("div", {
      class: "setting-desc"
    }, app.translator.trans('ziven-dress-up.forum.settings.crop_enabled.desc'))), m("div", {
      class: 'toggle' + (this.cropEnabled ? ' on' : ''),
      onclick: () => this.toggleCrop(),
      role: "switch",
      "aria-checked": this.cropEnabled ? 'true' : 'false',
      title: this.cropEnabled ? app.translator.trans('ziven-dress-up.forum.settings.crop_enabled.tooltip_on') : app.translator.trans('ziven-dress-up.forum.settings.crop_enabled.tooltip_off')
    }, m("div", {
      class: "knob"
    }))));
  }
}
_defineProperty(SettingsModal, "isDismissibleViaBackdropClick", false);
_defineProperty(SettingsModal, "isDismissibleViaCloseButton", true);
flarum.reg.add('ziiven-dress-up', 'forum/components/SettingsModal', SettingsModal);